<div class="widget-tile">
  <span>{{ widgetDataHolder.title }}</span>
  <div *ngFor="let dataItem of widgetDataHolder.data.entries()">
    <span class="tile-text">{{ dataItem[0] }} : {{ dataItem[1] }}</span>
  </div>
</div>
